import { AbstractControl, ControlValueAccessor, NgControl } from '@angular/forms';
import { Component, OnInit, Optional, Self, Input } from '@angular/core';

@Component({
  selector: 'fgbcl-select-region',
  templateUrl: './select-region.component.html',
  styleUrls: ['./select-region.component.scss']
})
export class SelectRegionComponent implements OnInit, ControlValueAccessor {

  control: AbstractControl | any;
  onChangeCallback = (_: any) => {};
  onTouchedCallback = () => {};
  innerValue: string = '';
  @Input() label: string;
  @Input() options: any[] = [null];

  constructor(@Optional() @Self() private ngControl: NgControl) { 
    if( this.ngControl ) this.ngControl.valueAccessor = this;
  }

  ngOnInit(): void {
    if( this.ngControl ){
      this.control = this.ngControl.control;
      this.control.updateValueAndValidity();
    }
  }

  writeValue(value: string): void {
    this.innerValue = value;
    this.onChangeCallback(this.innerValue);
  }

  registerOnChange(fn: any): void {
    this.onChangeCallback = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedCallback = fn;
  }
}
